var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalExaminationFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#medical-examination-fill_svg__clip0_230_2227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 14c0-2.2-1.8-4-4-4s-4 1.8-4 4c0 1.9 1.3 3.4 3 3.9V22H9v-5h2.3c1.5 0 2.8-1.1 3-2.6l1.6-11.1c.1-.6-.1-1.2-.5-1.6-.4-.4-1-.7-1.6-.7H12c0-.6-.4-1-1-1s-1 .4-1 1v2c0 .6.4 1 1 1s1-.4 1-1h1.8l-1.6 11.1c-.1.5-.5.9-1 .9H4.7c-.5 0-.9-.4-1-.9L2.2 3H4c0 .6.4 1 1 1s1-.4 1-1V1c0-.6-.4-1-1-1S4 .4 4 1H2.2c-.6 0-1.2.3-1.6.7-.4.4-.6 1-.5 1.6l1.6 11.1c.3 1.5 1.6 2.6 3 2.6H7v6c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-5.1c1.7-.5 3-2 3-3.9z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "medical-examination-fill_svg__clip0_230_2227"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgMedicalExaminationFill;